package com.fireavert.react.pages.my_fire_risk

import com.fireavert.react.shared.styles.MobileStyles
import emotion.css.ClassName
import web.cssom.*

object FireRiskStyles {
    val riskTablePadding = ClassName {
        padding = Padding(0.px, 10.px)
    }
    val riskLevelPadding = ClassName {
        display = Display.Companion.flex
        gap = 7.5.px
    }
    val whiteBox = ClassName {
        backgroundColor = Color("#FFFFFF")
        borderRadius = 15.px
        padding = Padding(10.px, 10.px)
        display = Display.Companion.inlineFlex
        alignItems = AlignItems.Companion.center
        flexDirection = FlexDirection.Companion.column
        width = 100.pct
        gap = 10.px
        media(MediaQuery(MobileStyles.MOBILE_VIEW_WIDTH)) {
            padding = Padding(10.px, 15.px, 10.px, 15.px)
            overflowX = Overflow.Companion.hidden
        }
    }
    val riskLabelParentStyle = ClassName {
        display = Display.Companion.flex
        color = Color("#000000")
        flexDirection = FlexDirection.Companion.row
        borderRadius = 10.px
        alignItems = AlignItems.Companion.center
        justifyContent = JustifyContent.Companion.flexStart
        padding = Padding(5.px, 0.px)
        media(MediaQuery(MobileStyles.MOBILE_VIEW_WIDTH)) {
            justifyContent = JustifyContent.center
        }
    }
    val riskArrowStyle = ClassName {
        display = Display.Companion.flex
        flexDirection = FlexDirection.Companion.row
        alignItems = AlignItems.Companion.center
        justifyContent = JustifyContent.Companion.spaceBetween
        width = 100.pct
        media(MediaQuery(MobileStyles.MOBILE_VIEW_WIDTH)) {
            fontSize = 0.75.rem
        }
    }
    val arrowStyle = ClassName {
        media(MediaQuery(MobileStyles.MOBILE_VIEW_WIDTH)) {
            width = 50.pct
        }
    }
    val riskLabelNumber = ClassName {
        fontSize = 1.75.rem
        fontWeight = FontWeight.Companion.bold
        padding = Padding(0.px, 20.px)
    }
    val riskLabelDescription = ClassName {
        display = Display.Companion.flex
        flexDirection = FlexDirection.Companion.row
        justifyContent = JustifyContent.Companion.flexEnd
        fontSize = 0.8.rem
        fontWeight = FontWeight.Companion.bold
        padding = Padding(0.px, 20.px)
        media(MediaQuery(MobileStyles.MOBILE_VIEW_WIDTH)) {
            display = None.none
        }
    }
    val riskLabelDivider = ClassName {
        width = 2.px
        alignSelf = AlignSelf.Companion.stretch
        backgroundColor = Color("#000000")
        color = Color("#000000")
        media(MediaQuery(MobileStyles.MOBILE_VIEW_WIDTH)) {
            display = None.none
        }
    }

    fun riskLevelEntry(riskLevelColor: String): ClassName {
        return ClassName {
            backgroundColor = Color(riskLevelColor)
            color = Color("#000000")
            textAlign = TextAlign.center
            justifyContent = JustifyContent.center
            alignItems = AlignItems.center
            width = 2.5.rem
            height = 2.5.rem
            fontWeight = FontWeight.bolder
            fontSize = 1.5.rem
            display = Display.inlineFlex
            boxSizing = BoxSizing.borderBox
            borderRadius = 4.px
            media(MediaQuery(MobileStyles.MOBILE_VIEW_WIDTH)) {
                width = 1.75.rem
                height = 1.75.rem
            }
        }
    }
}